import React, { useState } from 'react';
import '../styles/Calculadora.css';
import Aluguel from '../components/Calculadoras/Aluguel/Aluguel';
import FGTS from '../components/Calculadoras/FGTS/FGTS';
import PASEP from '../components/Calculadoras/PASEP/PASEP';
import Pensao from '../components/Calculadoras/Pensao/Pensao';
import RMC from '../components/Calculadoras/RMC/RMC';
import Superendividamento from '../components/Calculadoras/Superendividamento/Superendividamento';
import Criminal from '../components/Calculadoras/Criminal/Criminal';
import Revisional from '../components/Calculadoras/Revisional/Revisional';
import Trabalhista from '../components/Calculadoras/Trabalhista/Trabalhista';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBriefcase,
    faCoins,
    faHandHoldingDollar,
    faWallet,
} from '@fortawesome/free-solid-svg-icons';
import bgShapes from '../assets/BG-shapes-1.png';

const calculadoras = [
    {
        id: 'FGTS',
        title: 'Saldo FGTS',
        subtitle: 'Verbas e saldo projetado',
        icon: faWallet,
    },
    {
        id: 'PASEP',
        title: 'PASEP',
        subtitle: 'Abono proporcional',
        icon: faCoins,
    },
    {
        id: 'Pensao',
        title: 'Pensao alimenticia',
        subtitle: 'Base mensal e percentual',
        icon: faHandHoldingDollar,
    },
    {
        id: 'Trabalhista',
        title: 'Trabalhista',
        subtitle: 'Rescisao e reflexos',
        icon: faBriefcase,
    },
];

const Calculadora = () => {
    const [activeCalc, setActiveCalc] = useState('FGTS');
    const activeInfo = calculadoras.find((calc) => calc.id === activeCalc) || calculadoras[0];

    return (
        <div className="main-container-calculadora">
            <img className="bgshapes" src={bgShapes} alt="bgShapes" />

            <section className="calculadora-shell">
                <div className="calculadora-heading">
                    <div>
                        <span className="calculadora-kicker">Calculadora juridica</span>
                        <h1>Calculos</h1>
                    </div>
                    <div className="calculadora-active-pill">
                        <FontAwesomeIcon icon={activeInfo.icon} />
                        <span>{activeInfo.title}</span>
                    </div>
                </div>

                <div className="container-calculadora">
                    <aside className="container-esquerdo-calculadora" aria-label="Calculadoras">
                        {calculadoras.map((calc) => (
                            <button
                                className={`btn-esq-calculadora ${activeCalc === calc.id ? 'active' : ''}`}
                                key={calc.id}
                                onClick={() => setActiveCalc(calc.id)}
                                type="button"
                            >
                                <FontAwesomeIcon icon={calc.icon} />
                                <span>{calc.title}</span>
                                <small>{calc.subtitle}</small>
                            </button>
                        ))}
                    </aside>

                    <div className="container-direito-calculadora">
                        {activeCalc === 'Aluguel' && <Aluguel />}
                        {activeCalc === 'FGTS' && <FGTS />}
                        {activeCalc === 'PASEP' && <PASEP />}
                        {activeCalc === 'Pensao' && <Pensao />}
                        {activeCalc === 'RMC' && <RMC />}
                        {activeCalc === 'Superendividamento' && <Superendividamento />}
                        {activeCalc === 'Criminal' && <Criminal />}
                        {activeCalc === 'Revisional' && <Revisional />}
                        {activeCalc === 'Trabalhista' && <Trabalhista />}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Calculadora;
